var _effectorFileName = "/src/widgets/layouts/main/slider-cards/slider-cards.tsx";
import { useEffect, useState } from 'react';
import { Article } from '@/shared/components/article';
import { ContactModal } from '@/shared/components/contact-modal';
import { Button } from '@/shared/components/ui/button';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/shared/components/ui/card';
import { Carousel, CarouselApi, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/shared/components/ui/carousel';
import { Progress } from '@/shared/components/ui/progress';
import { CardItem } from './slider-card/slider-card';
import { SliderCardProps } from './types';
export const SliderCards = (props: SliderCardProps) => {
  const {
    cards,
    quizResult
  } = props;
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  const progress = current * 100 / count;
  useEffect(() => {
    if (!api) {
      return;
    }
    setCount(api.scrollSnapList().length);
    const currentCard = cards.findIndex(card => card.key === quizResult);
    setCurrent(currentCard + 1);
    api.on('select', () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api, quizResult]);
  const activeCardIndex = quizResult ? cards.findIndex(card => card.key === quizResult) : -1;
  useEffect(() => {
    if (api && activeCardIndex >= 0 && activeCardIndex < cards.length) {
      api.scrollTo(activeCardIndex);
    }
  }, [api, activeCardIndex, cards.length]);
  return <Article id="group-lessons-carousel">
      <h2 className="mb-8 header-h2">Программы</h2>

      <div className="hidden gap-4 md:grid md:grid-cols-2 lg:grid-cols-3">
        {cards.map((card, index) => <CardItem item={card} key={card.key} id={card.key} isActive={index === activeCardIndex} />)}

        <Card className="flex flex-col">
          <CardHeader className="min-h-[140px] pb-0">
            <CardTitle className="text-2xl font-medium">Не нашли нужный вариант?</CardTitle>
          </CardHeader>
          <CardContent>
            <p>Оставьте заявку, и мы подберем вам группу или индивидуального преподавателя</p>
          </CardContent>
          <CardFooter className="h-full items-end">
            <ContactModal entryPoint="GROUP_LESSONS_CARDS">
              <Button variant="cta" className="w-full px-6" aria-label="Записаться на бесплатную консультацию">
                Оставить заявку
              </Button>
            </ContactModal>
          </CardFooter>
        </Card>
      </div>

      <div className="md:hidden">
        <Carousel opts={{
        align: 'center',
        loop: true,
        inViewThreshold: 0.5
      }} setApi={setApi} className="md:hidden">
          <CarouselContent className="min-h-[400px] pb-6 sm:pb-8">
            {cards.map((card, index) => {
            return <CarouselItem key={index} className="flex justify-center sm:basis-1/2 md:basis-[40%] lg:basis-[42%] xl:basis-1/3 2xl:basis-[28%]" id={card.key}>
                  <CardItem id={card.key} item={card} isActive={index === activeCardIndex} />
                </CarouselItem>;
          })}
          </CarouselContent>

          <div className="pointer-events-none absolute inset-y-0 left-0 hidden h-full bg-gradient-to-r from-background xss:block sm:w-1/4"></div>
          <div className="pointer-events-none absolute inset-y-0 -right-1 hidden h-full bg-gradient-to-l from-background xss:block sm:w-1/4"></div>

          <CarouselPrevious className="left-0 top-[calc(100%+0.5rem)] translate-y-0" />
          <CarouselNext className="left-2 top-[calc(100%+0.5rem)] translate-x-full translate-y-0" />
        </Carousel>

        <Progress value={progress} className="ml-auto mt-4 w-24" />
      </div>
    </Article>;
};